import { Component, OnInit, ViewEncapsulation } from '@angular/core'

import { IQuestionContextView } from '..'
import { Question, AnswerChoice } from '../../../../../data/models'
import { QuestionViewService } from '../..'
import { Form, MultiRelationshipPrompt } from '../../../../../forms/models'

@Component({
  selector: 'mp-sentence-select-question-context-view',
  templateUrl: './sentence-select-question-context-view.html',
  styleUrls: ['./sentence-select-question-context-view.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SentenceSelectQuestionContextViewComponent implements IQuestionContextView, OnInit {
  public question: Question
  public form: Form<Question>
  public selectedSentence: string = ''
  public reviewMode: boolean = false

  private _PARAGRAPH_INDENT = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
  private _PARAGRAPH_END = '<br><br>'

  public get correctSentence(): string {
    return this._questionViewService.question.answerChoices[0].value
  }

  public get sentences() {
    return this.question.questionContext.getContextSentences()
  }

  public constructor(
    private _questionViewService: QuestionViewService
  ) { }

  public ngOnInit() {
    const answerChoiceGroupPrompt = this.form.getPrompt<MultiRelationshipPrompt<AnswerChoice>>('answerChoiceGroup')
    const answerChoicePrompt = answerChoiceGroupPrompt.forms[0].getPrompt('answerChoice')
    this.select(answerChoicePrompt.value)
    this.reviewMode = this._questionViewService.reviewMode
  }

  public select(sentence: string) {
    if (this.reviewMode) { return 0 }

    this.selectedSentence = sentence
    this._questionViewService.questionAnswered.emit([
      { value: sentence, choiceId: this.question.answerChoices[0].id }
    ])
  }

  public formatSentence(sentence) {
    return `${sentence.paragraphStart ? this._PARAGRAPH_INDENT : ''}${sentence.value} ${sentence.paragraphEnd ? this._PARAGRAPH_END : ''}`
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-context-view/sentence-select-question-context-view/sentence-select-question-context-view.component.ts